module.exports = __webpack_public_path__ + "img/tema-3-8.6d42ec29.png";